import { WebReportEvent, JsErrorReport } from '@slardar/sdk-web';
import BasePlugin from './base-plugin';

export default class ServiceWorkerPlugin extends BasePlugin {
  handle(event: JsErrorReport) {
    const { payload } = event;
    const { error } = payload;
    // modify js_error level to warning
    payload.extra = {
      ...payload.extra,
      level: 'warn',
      content: error.message,
    };
    if (error.name && !error.name?.startsWith('[')) {
      error.name = `[warn][ServiceWorker] - ServiceWorker Error`;
      error.message = 'Service worker error, details for extra.content';
    }
    return event;
  }

  shouldHandle(event: WebReportEvent): event is JsErrorReport {
    const reg = /ServiceWorker|service worker/i;
    return (
      event.ev_type === 'js_error' &&
      (reg.test(event.payload.error?.message || '') ||
        reg.test(event.payload.error?.stack || ''))
    );
  }
}
